import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "px-6 md:px-8 pt-6 pb-20 text-sm text-red-600"
}

import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

import NeueLoading from '@/components/neue/NeueLoading.vue'
import SecondaryNav from '@/components/SecondaryNav.vue'
import SecondaryTop from '@/components/SecondaryTop.vue'
import { agentSettingsPath } from '@/composables/useAgentSections'
import { useCateringAgent } from '@/composables/useCateringAgent'


export default {
  __name: 'AgentSettingsIndex',
  setup(__props) {

const router = useRouter()
const { load } = useCateringAgent()
const failed = ref(false)

onMounted(() =>
  load()
    .then(agent => router.replace(agentSettingsPath(agent ? agent.id : 'new')))
    .catch(() => {
      failed.value = true
    })
)

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(SecondaryTop, { text: "Agent settings" })
    ]),
    main: _withCtx(() => [
      (failed.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, " Your agent could not be loaded. Refresh the page to try again. "))
        : (_openBlock(), _createBlock(NeueLoading, {
            key: 1,
            loading: true
          }))
    ]),
    _: 1
  }))
}
}

}